export default __webpack_public_path__ + "static/media/words.2ea789a8.png";